<particle-workflow-wizard *ngIf="workflowId" [workflowId]="workflowId"
                          [apiEndpointKey]="apiEndpointKey"
                          (GridCellValueChanged)="onGridCellValueChange($event)">
</particle-workflow-wizard>
